import { Component ,TemplateRef , OnInit , ViewChild,PLATFORM_ID ,Inject} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { BreakpointObserver, BreakpointState, LayoutModule } from '@angular/cdk/layout';

import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';
import { HttpClient } from "@angular/common/http";
import { HttpClientModule } from '@angular/common/http';

import { MatDialog } from '@angular/material/dialog';

import {AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';
import { WordlistComponent } from '../../tools/wordlist/wordlist.component';

@Component({
  selector: 'new-analysis',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule,
    LayoutModule,
    HttpClientModule],
  templateUrl: './new-analysis.component.html',
  styleUrl: './new-analysis.component.css',
})

export class NewAnalysisComponent implements OnInit {
  isExpanded = false;
  splitCharacter: string = '';
  dialogRef: any;
  inputValue: string = '#'; // Inicializa el valor del campo de texto

  isScreenLarge: boolean = false;
  
  // Utilizamos @ViewChild para obtener una referencia al template
  @ViewChild('analysisOptionsDialog') analysisOptionsDialog!: TemplateRef<any>;

  // Analysis Service es para mandar los valores al Analysis Options
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
  public dialog: MatDialog,
  private analysisService: AnalysisServiceService,
  private breakpointObserver: BreakpointObserver,
  private facade: FacadeService,
  private http:HttpClient,
  private proyectoService: ProyectosService ) {
    
  }

  // Analysis Service es para mandar los valores al Analysis Options
  onEnglishTypeChange(event: any) {
    this.analysisService.changeEnglishType(event.target.value);
  }

  // Analysis Service es para mandar los valores al Analysis Options
  onAnalysisModeChange(event: any) {
    this.analysisService.changeAnalysisMode(event.target.value);
  }

  // Analysis Service es para mandar los valores al Analysis Options
  onTargetCEFRChange(event: any) {
    this.analysisService.changeTargetCEFR(event.target.value);
  }

  onExcludeDigitsChange(event: any) {
    this.analysisService.changeExcludeDigits(event.checked);
  }

  onUseKnownWordsChange(event: any) {
    this.analysisService.changeUseKnownWords(event.checked);
  }

  onSplitCharacterChange(event: any) {
    this.analysisService.changeSplitCharacter(event.target.value);
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    


    // Abrir el cuadro de diálogo cuando se cargue el componente
    setTimeout(() => {
      this.openAnalysisOptions();
    }, 0);

    // Observa los cambios en el tamaño de la ventana
    this.breakpointObserver.observe(['(max-width: 1000px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        // Si el ancho es menor a 1000px, ajusta el tamaño del modal
        if (this.dialogRef) {
          this.dialogRef.updateSize('80%', '80%');
        }
      } else {
        // Si el ancho es mayor o igual a 1000px, usa el tamaño predeterminado
        if (this.dialogRef) {
          this.dialogRef.updateSize('670px', '670px');
        }
      }
    });

    this.wordlist()

    this.proyectoService.refreshTextBox$.subscribe(() => { 
      setTimeout(() => {
        this.wordlist();
      }, 1000);
      
    });

    this.proyectoService.refreshAnalyse$.subscribe(() => { 
      setTimeout(() => {
        this.wordlist();
      }, 1000);
    });
  }

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }
  

  // Método para capturar el valor ingresado
  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.splitCharacter = inputElement.value;
    console.log(this.splitCharacter);
  }

  // Método para alternar la expansión y cambiar el tamaño del cuadro de diálogo
  toggleExpand(): void {
  this.isExpanded = !this.isExpanded;
  if (this.dialogRef) {
    const newWidth = this.isScreenLarge ? '670px' : '80%';
    const newHeight = this.isExpanded ? (this.isScreenLarge ? '679px' : '80%') : (this.isScreenLarge ? '523px' : '80%');
    this.dialogRef.updateSize(newWidth, newHeight);
  }
}

public nombresListas: { id: any; nombre: string }[] = [];
wordlistselect: any = null;

  async wordlist() {
    try {
      const storedWordlist = sessionStorage.getItem("data_wordlist");
      let respuesta2: any[] = [];

      if (storedWordlist) {
        try {
          respuesta2 = JSON.parse(storedWordlist);
        } catch (error) {
          sessionStorage.removeItem("data_wordlist");
        }
      }

      if (!respuesta2.length) {
        respuesta2 = await this.facade.getAllwordlists(this.http,localStorage.getItem("text-inspector-django-token"));
        sessionStorage.setItem("data_wordlist", JSON.stringify(respuesta2));
      }
  
      // Verificar si hay datos y asignar los nombres e ids o agregar la opción "Pick a list"
      if (respuesta2 && respuesta2.length > 0) {
        this.nombresListas = [
          { id: null, nombre: "Pick a list" }, // Opción predeterminada
          ...respuesta2.map((list: any) => ({
            id: list.id,
            nombre: list.nombre,
          })),
        ];
      } else {
        this.nombresListas = [{ id: null, nombre: "Pick a list" }]; 
      }
    } catch (error) {
      console.error("Error al cargar los nombres:", error);
      this.nombresListas = [{ id: null, nombre: "Pick a list" }]; 
    }
  }

  onWordlistChange(event: any) {
    const selectedValue = event.target.value; // Obtén el ID seleccionado
    const selectedOption = this.nombresListas.find((lista) => String(lista.id) === selectedValue);
    if (selectedOption) {
      this.wordlistselect = selectedOption.id;
      this.analysisService.changeWordlist(selectedOption.id);
      console.log("Wordlist seleccionada:", selectedOption);
    } else {
      this.wordlistselect = null;
      this.analysisService.changeWordlist(null);
      console.log("No se encontró la opción seleccionada.");
    }
   
  }

    createList(){
      const dialogRef = this.dialog.open(WordlistComponent, {
        data: { 
          isEditing: false, // Indicador de que es modo edición
        },
        backdropClass: 'dialog-backdrop-dark' // Fondo oscuro para este diálogo
      });
      dialogRef.afterClosed().subscribe(result => {
        const createdWordlist = this.normalizeWordlistResponse(result);
        if (createdWordlist) {
          this.upsertWordlistInSession(createdWordlist);
          this.setWordlistOptionsFromSession();
          this.wordlistselect = createdWordlist.id;
          this.analysisService.changeWordlist(createdWordlist.id);
          this.analysisService.notifyWordlistCreated(createdWordlist);
        }
      });
    }

  private normalizeWordlistResponse(result: any): any | null {
    if (!result || result === true) {
      return null;
    }

    const raw = result.lista ?? (result.data && !Array.isArray(result.data) ? result.data : result);
    const id = raw.id ?? raw.wordlist_id ?? raw.pk;
    const nombre = raw.nombre ?? raw.name;
    const listado = raw.listado ?? raw.wordlist ?? raw.words ?? [];

    if (id === null || id === undefined || !nombre) {
      return null;
    }

    return {
      ...raw,
      id,
      nombre,
      listado,
    };
  }

  private upsertWordlistInSession(wordlist: any): void {
    const storedWordlist = sessionStorage.getItem("data_wordlist");
    let parsedWordlist: any[] = [];

    if (storedWordlist) {
      try {
        parsedWordlist = JSON.parse(storedWordlist);
      } catch (error) {
        parsedWordlist = [];
      }
    }

    const index = parsedWordlist.findIndex((item: any) => item.id === wordlist.id);
    if (index >= 0) {
      parsedWordlist[index] = { ...parsedWordlist[index], ...wordlist };
    } else {
      parsedWordlist.push(wordlist);
      sessionStorage.setItem("WordLists", String(parsedWordlist.length));
    }

    sessionStorage.setItem("data_wordlist", JSON.stringify(parsedWordlist));
  }

  private setWordlistOptionsFromSession(): void {
    const storedWordlist = sessionStorage.getItem("data_wordlist");
    let parsedWordlist: any[] = [];

    if (storedWordlist) {
      try {
        parsedWordlist = JSON.parse(storedWordlist);
      } catch (error) {
        parsedWordlist = [];
      }
    }

    this.nombresListas = parsedWordlist.length > 0
      ? [
          { id: null, nombre: "Pick a list" },
          ...parsedWordlist.map((list: any) => ({
            id: list.id,
            nombre: list.nombre,
          })),
        ]
      : [{ id: null, nombre: "Pick a list" }];
  }

  // Método para abrir el diálogo
  openAnalysisOptions(): void {
    // Cerrar el diálogo si ya está abierto
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    const width = this.isScreenLarge ? '670px' : '80%';
    const height = this.isExpanded ? (this.isScreenLarge ? '679px' : '80%') : '523px';

    this.dialogRef = this.dialog.open(this.analysisOptionsDialog, {
      panelClass: 'custom-dialog-container',
      width: width,
      height: height,
      backdropClass: 'dialog-backdrop-dark'
    });
    
    // Ajustar el tamaño del diálogo si el ancho es menor a 1000px
    this.breakpointObserver.observe(['(max-width: 1000px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.dialogRef.updateSize('80%', '80%');
      }
    });
  }

  // Método para alternar la apertura/cierre del diálogo
  toggleDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null; // Asegúrate de restablecer la referencia
    } else {
      this.openAnalysisOptions();
    }
  }

  closeDialog(): void { 
    if (this.dialogRef) { this.dialogRef.close(); }
  }
}
